import { Schema } from 'mongoose';
import LocalizedField, { ILocalizedText } from './localized-text';
import ServiceOptions, { IServiceOptions } from './service-options';

export interface IGroupedServiceOptions {
  groupName: ILocalizedText;
  required: boolean;
  options: IServiceOptions[];
}
const groupedOptions = new Schema(
  {
    groupName: {
      type: LocalizedField,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    options: {
      type: [ServiceOptions],
      default: [],
    },
  },
  { _id: false },
);

export default groupedOptions;
